/**
 * @desc 审核盘点单
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.InventoryWorkflowDto, options?: any) {
  return updateResponse(
    http(URL + `/inventoryMaster/approval`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
